<template>
  <WsMain>
    <WsCRUD
      v-if="isMounted"
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :showFields="showFields"
      :showExpand="false"
      :pageMode="true"
      :rowClickRead="true"
      :inRowBtnUpdate="false"
      :inRowBtnDelete="false"
      :filterSelects="filterSelects"
      :filterProps="filterProps"
      :isCreatable="false"
      :customUrlParams="customUrlParams"
      @filter-select="$_onFilterSelect($event)"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/act_cnt_review";
import idtfModel from "@/models/act_idtf_assignment";
export default {
  data: () => ({
    isMounted: false,
    modelName: model.modelName,
    label: model.label,
    fields: idtfModel.fields,
    filterSelects: [
      {
        type: "switch-tabs",
        label: "",
        textKey: "name",
        modelName: "act_cnt_status",
        defaultValue: "2",
        items: [
          {
            text: "覆核中",
            value: "2",
          },
          {
            text: "已完成",
            value: "3",
          },
        ],
      },
    ],
    filterProps: {},
    showFields: [
      "act_version",
      "km_reviewers",
      "km_owners",
      "km_backups",
      "act_cnt_updated_admin",
      "act_cnt_updated_at",
    ],
    customUrlParams: {
      status: '2'
    },
  }),
  methods: {
    $_onFilterSelect($event) {
      this.filterProps = {
          ...$event,
        };
    },
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>